<template>
  <el-form label-width="70px">
    <div class="form" @keyup.enter="handleClickSearch">
      <el-form-item style="width: 30%" label="关键词：">
        <el-input
          v-model="form.keyword"
          placeholder="请输入搜索关键字"
          clearable
          @clear="handleClickSearch"
        ></el-input>
      </el-form-item>
      <el-form-item style="width: 70%" label="日期：">
        <div style="form-item">
          <el-date-picker
            style="width: 15%"
            v-model="form.startTm"
            type="date"
            placeholder="开始日期"
            :picker-options="startPickerOptions"
          >
          </el-date-picker>
          <span style="margin:0 10px">至</span>
          <el-date-picker
            style="width: 15%"
            v-model="form.endTm"
            type="date"
            placeholder="结束日期"
            :picker-options="endPickerOptions"
          >
          </el-date-picker>
          <common-button
            style="margin-left: 10px"
            image
            class="icon-sousuo iconfont"
            @click="handleClickSearch"
            >查询
          </common-button>
        </div>
      </el-form-item>
    </div>
    <div class="btns">
      <common-button
        size="default"
        image
        :type="showDataType === '-1' ? 'primary' : 'cancel'"
        @click="showTypeQuery('-1')"
        >查看全部
      </common-button>
      <common-button
        v-if="showPublishButton"
        size="default"
        image
        :type="showDataType === '0' ? 'primary' : 'cancel'"
        @click="showTypeQuery('0')"
        >我发布的
      </common-button>
      <common-button
        v-if="showReviewButton"
        size="default"
        image
        :type="showDataType === '1' ? 'primary' : 'cancel'"
        @click="showTypeQuery('1')"
        >待审核
      </common-button>
      <common-button
        v-show="!unApproveMember && showNewArticle"
        type="cancel"
        image
        class="iconfont icon-24gl-folderPlus"
        @click="showTypeQuery('add')"
        >&nbsp;新增文章
      </common-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "DetailForm",
  props: {
    showPublishButton: {
      type: Boolean,
      default: false
    },
    showReviewButton: {
      type: Boolean,
      default: false
    },
    showNewArticle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDataType: "-1",
      form: {
        startTm: null,
        endTm: null,
        keyword: ""
      },
      startPickerOptions: {
        disabledDate: t => {
          return this.form.endTm
            ? t.getTime() > new Date(this.form.endTm).getTime() - 86400000
            : false;
        }
      },
      endPickerOptions: {
        disabledDate: t => {
          return this.form.startTm
            ? t.getTime() < new Date(this.form.startTm).getTime()
            : false;
        }
      }
    };
  },
  computed: {
    unApproveMember() {
      return this.$store.state.userPowerStore.unApproveMember;
    }
  },
  mounted() {
    if (this.$route.query.flag) {
      this.showDataType = this.$route.query.flag;
    } else {
      this.showDataType = "-1";
    }
  },
  methods: {
    handleClickSearch() {
      this.$emit("search", this.form);
    },
    showTypeQuery(type) {
      if (type !== "add") {
        this.showDataType = type;
      }
      this.$emit("showTypeQuery", type);
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  display: flex;
  overflow: auto;
  white-space: nowrap;
  align-items: center;
  width: 100%;
  &-item {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DetailForm.vue